import { ClientConfigurationApiModel } from '@cxb/content-stb-api/model/clientConfigurationApiModel';
import { ConfigEntryApiModel } from '@cxb/content-stb-api/model/configEntryApiModel';
import { Entity } from '@nx-data/nx-data';

export class ClientConfigApiEntity extends Entity implements ClientConfigurationApiModel {
  public static readonly singletonID = 'Config-ID';
  public configEntries: Array<ConfigEntryApiModel>;
}
